// @ts-check
/* global module */
'use_strict';

export class OrderProgressBarsView {

    /**
     * Instantiate the class, and call the function to handle the progress bars.
     */
    constructor() {
        this.handle_progress_bars();
    }

    /**
     * Style and organize the progress bars and checkout steps.
     * 
     * @returns {void}
     */
    handle_progress_bars():void {
        // Style Checkout Progress Bar
        const progress_bars = document.getElementsByClassName('tv-checkout-progress-bar');
        const progress_bar_html = '<div class="tv-checkout-progress-bar"></div>';
        const checkout_steps = document.getElementsByClassName('tv-checkout-step');
        const completed_steps = document.getElementsByClassName('tv-checkout-step-completed');

        // Create and fill in progress bars based on number of completed steps
        for (const checkout_step of checkout_steps) {
            checkout_step.insertAdjacentHTML("afterend", progress_bar_html);
        }

        for (let i = 0; i < progress_bars.length; i++) {
            if (i < completed_steps.length - 1) {
                progress_bars[i].classList.add('tv-checkout-progress-bar-completed');
            }
        }
    }
}

export function init() {
    if (document.getElementsByClassName('tv-checkout-progress-container')[0]) {
        (() => new OrderProgressBarsView())();
    }
}

